import React from 'react';
import { QrCode, Download } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';

// Printable QR card shown in the property detail modal — field agents can
// paste it onto flyers. Downloads a 512×512 white-backed PNG so it prints
// cleanly regardless of the source SVG viewport.
export const PropertyQrCard = ({ property, shareUrl }) => {
  const qrId = `property-qr-${property.id}`;

  const downloadPng = () => {
    const svg = document.getElementById(qrId);
    if (!svg) return;
    const xml = new XMLSerializer().serializeToString(svg);
    const svgBlob = new Blob([xml], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const size = 512;
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, size, size);
      ctx.drawImage(img, 0, 0, size, size);
      URL.revokeObjectURL(url);
      const png = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = png;
      a.download = `acremitra-${(property.property_code || property.id).toLowerCase()}.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    };
    img.src = url;
  };

  return (
    <div
      className="rounded-xl border-2 border-dashed border-emerald-300 bg-emerald-50/60 p-4 flex items-start gap-4"
      data-testid="property-qr-card"
    >
      <div className="bg-white p-2 rounded-lg border border-emerald-200 shrink-0">
        <QRCodeSVG
          id={qrId}
          value={shareUrl}
          size={104}
          level="M"
          includeMargin={false}
          fgColor="#064e3b"
          bgColor="#ffffff"
          data-testid="property-qr-svg"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 text-emerald-800 font-bold text-xs uppercase tracking-widest">
          <QrCode size={12} /> Scan-to-view
        </div>
        <div className="mt-1 text-sm font-semibold text-slate-900 truncate">
          {property.property_code || property.title}
        </div>
        <div className="text-[11px] text-slate-500 mt-0.5">
          Print on flyers so buyers can jump straight to this listing on their phone.
        </div>
        <button
          type="button"
          onClick={downloadPng}
          className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold text-white bg-emerald-700 hover:bg-emerald-800 px-3 py-1.5 rounded-full transition-colors"
          data-testid="property-qr-download"
        >
          <Download size={12} /> Download PNG
        </button>
      </div>
    </div>
  );
};

export default PropertyQrCard;
